export enum AbandonmentMailsWhatsAppEnabledPreconditionState {
  Met = "met",
  NotMet = "not_met"
}

export type GetAbandonmentMailsWhatsAppEnabledResponse = {
  enabled: boolean;
  canEnable: boolean;
  preconditions: {
    whatsappIntegration: AbandonmentMailsWhatsAppEnabledPreconditionState;
    phoneNumber: AbandonmentMailsWhatsAppEnabledPreconditionState;
  };
};
